import React from 'react';
import Button from './Button';

/**
 * Backward compatibility wrapper for PrimaryButton.
 * Internally uses the unified modular Button component.
 */
const PrimaryButton = ({
  children,
  handleClick,
  onClick,
  disable,
  disabled,
  loading,
  type = 'button',
  size = 'base',
  className = '',
  wrapperClassName = '',
  id,
  ...rest
}) => {
  const combinedClassName = `${wrapperClassName ? wrapperClassName + ' ' : ''}${className}`.trim();

  return (
    <Button
      id={id}
      type={type}
      variant="primary"
      size={size}
      loading={loading}
      disabled={disable || disabled}
      onClick={handleClick || onClick}
      className={combinedClassName}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
